// extracted by mini-css-extract-plugin
export default {"logout__modal":"LogoutModal_logout__modal__ZoyoA","logout__text":"LogoutModal_logout__text__V8tKI","logout__buttons":"LogoutModal_logout__buttons__b0pel"};